import { Form } from './Form';
import React from 'react';
import { Button, CardBody } from '../components/Bootstrap';
import { AuthService, AuthTokenResponse } from '../AuthService';

const schema = {
  required: ['firstName', 'lastName', 'email', 'password', 'confirmPassword', 'phone'],
  properties: {
    firstName: {
      id: '/properties/firstName',
      type: 'string',
      title: 'First Name',
    },
    lastName: {
      id: '/properties/lastName',
      type: 'string',
      title: 'Last Name',
    },
    email: {
      id: '/properties/email',
      type: 'string',
      title: 'Email',
    },
    password: {
      id: '/properties/password',
      type: 'string',
      title: 'Password',
    },
    confirmPassword: {
      id: '/properties/confirmPassword',
      type: 'string',
      title: 'Confirm Password',
    },
    phone: {
      id: '/properties/phone',
      type: 'string',
      title: 'Phone',
    },
  },
  type: 'object',
};

const uiSchema = {
  email: {
    'ui:disabled': true,
  },
  password: {
    'ui:widget': 'password',
  },
  confirmPassword: {
    'ui:widget': 'password',
  },
};

interface CreateAccountFormProps {
  onLogin: (data: { email: string; password: string }, authResult: AuthTokenResponse) => void;
  auth: AuthService;
  buttonText?: string;
  invite: {
    email: string;
    firstName: string;
    lastName: string;
  };
}

export class CreateAccountForm extends React.Component<CreateAccountFormProps, any> {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: null,
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  async onSubmit({ formData }) {
    const { email, password, phone, confirmPassword, firstName, lastName } = formData;
    if (password !== confirmPassword) {
      this.setState({ error: 'Your passwords do not match.' });
      return;
    }

    this.setState({ error: null, loading: true });
    try {
      await this.props.auth.register(email, password, phone, firstName, lastName);
      const authResponse = await this.props.auth.login(email, password);
      await this.props.onLogin({ email, password }, authResponse);
    } catch (err) {
      let error = err.message;
      if (err.name === 'PasswordStrengthError') {
        error = 'Passwords must be at least 6 characters long.';
      } else if (err.name === 'InternalExtensibilityError') {
        error = 'Please double check your phone number.';
      }

      this.setState({ error, loading: false });
    }
  }

  renderForm() {
    const props = {
      uiSchema,
      onSubmit: this.onSubmit,
      formData: {
        email: this.props.invite.email,
        firstName: this.props.invite.firstName,
        lastName: this.props.invite.lastName,
      },
      schema,
      className: 'slim',
    };

    return (
      <Form {...props}>
        <div className='mt-5 text-center'>
          <Button type='submit' color='primary' className='btn--rounded-padded'>
            {this.props.buttonText || 'Next'}
          </Button>
        </div>
      </Form>
    );
  }

  renderContent() {
    if (this.state.loading) {
      return 'Loading...';
    } else {
      return this.renderForm();
    }
  }

  render() {
    return (
      <CardBody>
        <h3 className='text-center modal-title mb-3 mt-2'>Create Account</h3>
        <p>{this.state.error}</p>
        {this.renderContent()}
      </CardBody>
    );
  }
}
